export default __webpack_public_path__ + "static/media/tunic_of_the_doomsayer.6a8a8fee.jpg";